// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j_dd","col":"styles_col__1U54_"};